import { LOCATION_CHANGE } from 'redux-first-history'

const routerLocationsReducer = (
  state = {
    location: {},
    prevLocation: {}
  },
  action
) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          location: action.payload,
          prevLocation: state.location
        }
      )
    default:
      return state
  }
}

export default routerLocationsReducer
